<template>
  <div class="propertyoffice">
    <div class="header">
      <div class="title">物业移动、协同办公</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="position">
          <img :src="mobilepropertyoffice1" alt="">
        </div>
      </div>

      <div class="right">
        涵盖所有物业办公场景，帮助物业实现线上移动办公，省时省力，为物业管理降本增效。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilepropertyoffice1 from '../../../../assets/product/mobilepropertyoffice1.png'

export default {
  setup() {
    return reactive({
      mobilepropertyoffice1
    });
  },
};
</script>

<style scoped>
.propertyoffice {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .left .logo img {
  width: 332px;
}
.body .left .position {
  width: 92vw;
  margin: 0 auto;
}
.body .left .position img {
  width: 238px;
}
.body .right {
  width: 92vw;
  margin: 16px auto 0;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
